function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "organization_profile",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.2,0.9 L6.2,6.9 L0.9,6.9 C0.4,6.9 0,7.3 0,7.8 L0,18.9 L6.2,18.9 L8.5,18.9 L16.2,18.9 L16.2,13.8 C16.3,13.7 16.8,13.2 17.6,13.2 C18.4,13.2 18.9,13.7 19,13.8 L19,18.9 L20.7,18.9 L20.7,0.9 C20.7,0.4 20.3,0 19.8,0 L7.1,0 C6.6,0 6.2,0.4 6.2,0.9 Z M4.5,15.9 L1.7,15.9 L1.7,13 L4.5,13 L4.5,15.9 Z M4.5,11.8 L1.7,11.8 L1.7,8.8 L4.5,8.8 L4.5,11.8 Z M7.8,1.9 L10.6,1.9 L10.6,4.8 L7.8,4.8 L7.8,1.9 Z M7.8,5.9 L10.6,5.9 L10.6,8.8 L7.8,8.8 L7.8,5.9 Z M10.7,12.9 L7.9,12.9 L7.9,9.9 L10.7,9.9 L10.7,12.9 Z M14.8,8.8 L12,8.8 L12,5.9 L14.8,5.9 L14.8,8.8 Z M14.8,4.8 L12,4.8 L12,1.9 L14.8,1.9 L14.8,4.8 Z M19,8.8 L16.2,8.8 L16.2,5.9 L19,5.9 L19,8.8 Z M19,4.8 L16.2,4.8 L16.2,1.9 L19,1.9 L19,4.8 Z",
  id: "path-1"
})));

function SvgOrganizationProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "19px",
    viewBox: "0 0 21 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Organization Profile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationProfile);
export default __webpack_public_path__ + "static/media/organization_profile.3f3e714a.svg";
export { ForwardRef as ReactComponent };